import { axiosInstance } from "../../config/axios";
import { APIURL } from "../../configApi";

const AuthService = {};
AuthService.login = (data) => {
  return axiosInstance.post(`${APIURL}/global/auth/sing_in`, data);
};

export default AuthService;
